import { Box, Stack, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface CompactClientWizardStepperProps {
  activeStep: number;
  totalStepCount: number;
}

const PREFIX = 'CompactClientWizardStepper';

const classes = {
  circle: `${PREFIX}-circle`,
  activeStepCircle: `${PREFIX}-activeStepCircle`,
  totalStepCircle: `${PREFIX}-totalStepCircle`,
};

const StyledStack = styled(Stack)(({ theme }) => ({
  width: 143,
  height: 56,
  borderRadius: 100,
  backgroundColor: 'white',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),

  [`& .${classes.circle}`]: {
    ...theme.typography.body2,
    width: 24,
    height: 24,
    borderRadius: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
  },
  [`& .${classes.activeStepCircle}`]: {
    backgroundColor: theme.palette.lightTextPrimary.main,
  },
  [`& .${classes.totalStepCircle}`]: {
    backgroundColor: theme.palette.lightTextDisabled.main,
  },
}));

export default function CompactClientWizardStepper({
  activeStep,
  totalStepCount,
}: CompactClientWizardStepperProps) {
  const { t } = useTranslation('common');
  return (
    <StyledStack direction="row">
      <Box className={`${classes.activeStepCircle} ${classes.circle}`}>
        {activeStep}
      </Box>
      <Typography variant="subtitle1">{t('common.of')}</Typography>
      <Box className={`${classes.totalStepCircle} ${classes.circle}`}>
        {totalStepCount}
      </Box>
    </StyledStack>
  );
}
